// Mock catalog of reusable Input Data definitions. In production this list
// will be fetched from the backend (e.g. a shared dictionary of business
// variables). The shape is intentionally simple so replacing the defaults
// with a server response is a one-line change in the consumer.
//
// Pass a different array via `new DrdEditor(container, { inputCatalog: [...] })`
// to override. Set to `[]` to hide the catalog section entirely.
//
// Each entry produces:
//   - A draggable chip in the palette's "Catálogo" group.
//   - When dropped on the canvas, an <inputData> with a matching
//     <variable typeRef="…"> whose name is taken from `name`.

export const DEFAULT_INPUT_CATALOG = [
  {
    key: 'cliente.edad',
    name: 'edad',
    label: 'Edad del cliente',
    typeRef: 'integer',
    description: 'Edad en años cumplidos',
    category: 'Cliente',
  },
  {
    key: 'cliente.ingresoMensual',
    name: 'ingresoMensual',
    label: 'Ingreso mensual',
    typeRef: 'double',
    description: 'Ingreso bruto mensual declarado',
    category: 'Cliente',
  },
  {
    key: 'cliente.puntajeBuro',
    name: 'puntajeBuro',
    label: 'Puntaje de buró',
    typeRef: 'integer',
    description: 'Score crediticio (300–900)',
    category: 'Cliente',
  },
  {
    key: 'solicitud.monto',
    name: 'montoSolicitado',
    label: 'Monto solicitado',
    typeRef: 'double',
    description: 'Valor del crédito en la moneda local',
    category: 'Solicitud',
  },
  {
    key: 'solicitud.plazoMeses',
    name: 'plazoMeses',
    label: 'Plazo (meses)',
    typeRef: 'integer',
    description: 'Duración del crédito en meses',
    category: 'Solicitud',
  },
  {
    key: 'historial.siniestros5a',
    name: 'historialSiniestros',
    label: 'Siniestros 5 años',
    typeRef: 'integer',
    description: 'Número de siniestros en los últimos 5 años',
    category: 'Historial',
  },
  {
    key: 'producto.tipo',
    name: 'tipoProducto',
    label: 'Tipo de producto',
    typeRef: 'string',
    description: 'Identificador del producto contratado',
    category: 'Producto',
  },
];
